import React from 'react';
import Styled from 'styled';

import ResponsiveImageView from 'lib/images/responsive-image-view';
import ImageView from 'lib/images/image-view';
import withFileThumbnail from 'lib/images/with-file-thumbnail';

import defaultStyles from './file-thumbnail.scss';

interface Props {
    file?: File;
    url?: string;
    value?: any;
    styles: typeof defaultStyles;
    orientation: any;
}

class FileThumbnail extends React.Component<Props> {
    render() {
        const { file, url, value, styles, orientation } = this.props;

        return (
            <div className={styles.fileThumbnail}>
                {file && url ? (
                    <ImageView
                        alt={file.name}
                        aspectFill={true}
                        src={url}
                        orientation={orientation}
                        sizes={{ xs: 25 }}
                    />
                ) : (
                    <ResponsiveImageView image={value} aspectFill={true} sizes={{ xs: 25 }} />
                )}
            </div>
        );
    }
}

export default withFileThumbnail()(Styled(defaultStyles)(FileThumbnail));
